module.exports = __webpack_public_path__ + "img/cat_11858.189a4153.png";